// Which RECORD TYPES a level pools across its own children. One field name at
// every level — Network across its divisions and groups, Division across its
// groups, Organization across its offices, Office across its teams — so adding
// a level costs nothing.
//
// Three states, not a boolean. "Inherit" is the default and is NOT the same as
// "Closed": inherit takes whatever a level above decided, closed is a
// deliberate opt-out that overrides it. Most specific wins.
//
// Who is allowed to decide is Network.controlledBy at path "sharing.buyers" —
// a level setting a value it is not permitted to set is ignored by the backend.

export const SHARED_RECORD_TYPES = [
  {
    key: "buyers",
    name: "Buyers",
    description: "Buyer profiles, enquiries and match history",
  },
  {
    key: "contacts",
    name: "Contacts",
    description: "Prospect and appraisal contact database",
  },
  {
    key: "agents",
    name: "Agents",
    description: "Agent directory, for referrals",
  },
  {
    key: "properties",
    name: "Properties",
    description: "Listings and their campaign history",
  },
];

export const SHARING_STATES = [
  { value: "inherit", label: "Inherit" },
  { value: "open", label: "Open" },
  { value: "closed", label: "Closed" },
];

export const DEFAULT_SHARING_STATE = "inherit";

// The record types this level deliberately opened. Takes the `sharing` object
// itself, not the parent document.
export const getSharedRecordTypes = (sharing) =>
  SHARED_RECORD_TYPES.filter(
    (recordType) => sharing?.[recordType.key] === "open",
  );

// The record types this level deliberately closed — worth showing separately,
// because a closed entry is a decision rather than an absence.
export const getClosedRecordTypes = (sharing) =>
  SHARED_RECORD_TYPES.filter(
    (recordType) => sharing?.[recordType.key] === "closed",
  );

// null/undefined becomes "inherit" so the form always has a value to render.
export const buildSharingFormValues = (sharing) =>
  SHARED_RECORD_TYPES.reduce((acc, recordType) => {
    const value = sharing?.[recordType.key];
    acc[recordType.key] =
      value === "open" || value === "closed" ? value : DEFAULT_SHARING_STATE;
    return acc;
  }, {});

// Back to what the backend stores: "inherit" is absence, so it is sent as null
// rather than as a string the schema would reject.
export const buildSharingPayload = (values = {}) =>
  SHARED_RECORD_TYPES.reduce((acc, recordType) => {
    const value = values[recordType.key];
    acc[recordType.key] =
      value === "open" || value === "closed" ? value : null;
    return acc;
  }, {});

// How a stored value reads on a detail screen. Inherit is NOT "Private" — it
// takes whatever a level above decided, which may well be open.
export const SHARING_LABELS = {
  open: "Open",
  closed: "Closed",
  inherit: "Inherit",
};

export const SHARING_PILL = {
  open: "bg-green-100 text-green-800",
  closed: "bg-red-100 text-red-800",
  inherit: "bg-mediumgray text-darkergray",
};
